import { useState } from 'react'
import Sidebar from '../components/Sidebar'
import { Outlet } from 'react-router-dom'
import { AppHeader } from '../components/AppHeader'

export default function ShellLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  return (
    <>
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
      <AppHeader onOpenSidebar={() => setSidebarOpen(true)} />
      <div className='mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8'>
        <Outlet />
      </div>
      <footer className='mt-16 border-t border-gray-200 bg-white'>
        <div className='mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8'>
          <div className='flex items-center justify-between text-sm text-gray-600'>
            <div>
              © 2025{' '}
              <a
                href='https://proservecs.com/'
                target='_blank'
                rel='noopener noreferrer'
                className='text-slate-600 underline hover:text-slate-800'
              >
                Pro-Serve Customer Service
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
